import _ from 'lodash';

import { bindServices } from '@/services/api';
import { toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';

const api = bindServices('billingSubscriptions');

const namespace = 'billingSubscriptions';
const fetchRoute = 'billing/company-subscriptions';
const fetchParams = 'BillingSubscription';

const initialPagination = { page: 1, count: 0, totalPages: 0 };

const initialState = {
  list: [],
  pagination: initialPagination,
  orderBy: '',
  select: CoreQueries[fetchParams].paged.select,
  item: null,
  showForm: false,
  detail: false,
  id: null,
};

const BillingSubscriptionsModel = {
  namespace,
  state: initialState,

  effects: {
    *fetchList({ payload }, { call, put, select }) {
      try {
        const pageSize = yield select((state) => state.global.pageSize);
        const params = {
          ...CoreQueries[fetchParams].paged,
          pageSize,
          ...payload,
        };

        const res = yield call(api.getAll, {
          route: `${fetchRoute}/paged`,
          params,
          readPriority: true,
        });

        const items = res?.items || res?.data || [];
        const page = payload.page ?? 1;
        const limit = payload.limit ?? pageSize;
        const totalCount = res?.totalCount ?? res?.count ?? res?.total ?? items.length;
        yield put({
          type: 'queryData',
          payload: {
            ...res,
            limit,
            page,
            totalCount,
            items,
          },
        });
      } catch (e) {
        /*  */
      }
    },

    *fetchItem({ payload }, { call, put }) {
      try {
        const res = yield call(api.getById, {
          route: fetchRoute,
          id: payload.id,
          params: {
            ...(payload.detail ? CoreQueries[fetchParams]?.itemDetail : {}),
            ...(payload?.params && { ...payload.params }),
          },
        });
        const item = Array.isArray(res) ? res[0] : res;
        yield put({ type: 'queryItem', payload: item });
      } catch (e) {
        /*  */
      }
    },

    *showForm({ payload }, { put }) {
      yield put({ type: 'queryShowForm', payload });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({ type: 'queryOrderBy', payload });
    },

    *setPaginationPage({ payload }, { put }) {
      yield put({ type: 'queryPaginationPage', payload });
    },

    *resetState(_, { put }) {
      yield put({ type: 'reset' });
    },
  },

  reducers: {
    queryData(state, { payload }) {
      const items = payload.items ?? payload.data ?? state.list;
      return {
        ...state,
        list: items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    queryItem(state, { payload }) {
      return {
        ...state,
        item: payload,
      };
    },

    queryShowForm(state, { payload }) {
      return {
        ...state,
        showForm: payload.state,
        detail: payload.detail,
        id: payload.id,
        item: payload.item ?? null,
      };
    },

    queryOrderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    queryPaginationPage(state, { payload }) {
      return {
        ...state,
        pagination: { ...state.pagination, page: payload },
      };
    },

    reset() {
      return { ...initialState };
    },
  },
};

export default BillingSubscriptionsModel;
